import R from 'app/assets/R'
import { BaseTabs } from 'app/components/common/BaseTabs'
import { SectionBase } from 'app/components/common/SectionBase'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { useGetNewTumRegisterTotalStatus } from 'app/react-query/hook/newTumRegister'
import React, { useState } from 'react'
import {
  LabelComponent,
  TabKeysEnum,
} from '../EventManagement/RegisterActivity/components'
import ApproveUnionMembersTable from './components/ApproveUnionMembersTable'
import * as S from './styles'
import { ENewTumRegisterStatus } from './type'

const ApproveUnionMembers: React.FC = () => {
  const [tab, setTabs] = useState(TabKeysEnum.WAITING)
  const { data } = useGetNewTumRegisterTotalStatus()

  return (
    <S.ScrollWrapper>
      <HeaderPage titleI18nKey={R.strings.approve_union_members} />

      <SectionBase>
        <BaseTabs
          onChange={ta => setTabs(ta as TabKeysEnum)}
          items={[
            {
              key: ENewTumRegisterStatus?.WAITING,
              label: (
                <LabelComponent
                  tabActive={tab}
                  tabKey={TabKeysEnum.WAITING}
                  label="Đang chờ phê duyệt"
                  count={data?.[ENewTumRegisterStatus?.WAITING]}
                />
              ),
              children: (
                <ApproveUnionMembersTable
                  status={ENewTumRegisterStatus.WAITING}
                />
              ),
            },
            {
              key: ENewTumRegisterStatus?.ACCEPTED,
              label: (
                <LabelComponent
                  tabActive={tab}
                  tabKey={TabKeysEnum.ACCEPTED}
                  label="Đã phê duyệt"
                  count={data?.[ENewTumRegisterStatus?.ACCEPTED]}
                />
              ),
              children: (
                <ApproveUnionMembersTable
                  status={ENewTumRegisterStatus.ACCEPTED}
                />
              ),
            },
            {
              key: ENewTumRegisterStatus?.REJECTED,
              label: (
                <LabelComponent
                  tabActive={tab}
                  tabKey={TabKeysEnum.REJECTED}
                  label="Đã từ chối"
                  count={data?.[ENewTumRegisterStatus?.REJECTED]}
                />
              ),
              children: (
                <ApproveUnionMembersTable
                  status={ENewTumRegisterStatus.REJECTED}
                />
              ),
            },
          ]}
        />
      </SectionBase>
    </S.ScrollWrapper>
  )
}

export default ApproveUnionMembers
